import React from 'react';

const GrupoDespesaReceitaContext = React.createContext();

export default GrupoDespesaReceitaContext;
